import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    supplies: [],
    supply: {},
    supplied_good: {},
    new_supplied_good: {},
    new_supply: {},
    supply_form_validation: {
      code: [
        { required: true, message: 'Code is required', trigger: 'blur' },
      ],
      supplier_id: [
        { required: true, message: 'Supplier is required', trigger: 'blur' },
      ],
      outlet_id: [
        { required: true, message: 'Outlet is required', trigger: 'blur' },
      ],
    },
    supplied_good_form_validation: {
      name: [
        { required: true, message: 'Name is required', trigger: 'blur' },
      ],
      quantity: [
        { required: true, message: 'Quantity is required', trigger: 'blur' },
      ],
    },
  },
  actions,
  mutations,
  getters,
};
